function validateAndPushDataLayer(eventData) {
    // Valida si dataLayer existe, de lo contrario lo inicializa.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
}

const datalayerService = {};

datalayerService.registerStep0Social= async () => {
    const eventData = {
        'event': 'registerUser1',
        'step': '1',
        'dataname': 'social'
    };

    validateAndPushDataLayer(eventData);
}
// nombre, tipopersona(empresa o persona), documento, telefono, ciudad, como descubrio falkon
datalayerService.registerStep1 = async (name) => { //ya existe un datalayer para este evento
    if(name){
        const eventData = {
            'event': 'registerUser1',
            'step': '1',
            'dataname': window.btoa(name)
        };

        validateAndPushDataLayer(eventData);
    }
}
datalayerService.registerStep2 = async (documentType, document) => {
    if(documentType && document){
        const eventData = {
            'event': 'registerUser2',
            'step': '2',
            'datadocumenttype': documentType == '1' ? 'CC' : '',
            'datanumber': window.btoa(document)
        };

        validateAndPushDataLayer(eventData);
    }
}
datalayerService.registerStep3 = async (name, documentType, document) => {
    if(name, documentType && document){
        const eventData = {
            'event': 'registerUser3',
            'step': '3',
            'dataname': window.btoa(name),
            'datadocumenttype': documentType == '1' ? 'CC' : documentType == '2' ? 'NIT' : '',
            'datanumber': window.btoa(document),
        };

        validateAndPushDataLayer(eventData);
    }
}
datalayerService.registerStep4 = async (name, documentType, document, phone, city) => {
    if(name, documentType && document){
        const eventData = {
            'event': 'registerUser4',
            'step': '4',
            'dataname': window.btoa(name),
            'datadocumenttype': documentType == '1' ? 'CC' : documentType == '2' ? 'NIT' : '',
            'datanumber': window.btoa(document),
            'dataphone': window.btoa(phone),
            'datacity': window.btoa(city),
        };

        validateAndPushDataLayer(eventData);
    }
}
datalayerService.registerStep5 = async (name, documentType, document, phone, city, discover) => { //discoveroption
    if(name, documentType && document){
        const eventData = {
            'event': 'registerUser5',
            'step': '5',
            'dataname': window.btoa(name),
            'datadocumenttype': documentType == '1' ? 'CC' : documentType == '2' ? 'NIT' : '',
            'datanumber': window.btoa(document),
            'dataphone': window.btoa(phone),
            'datacity': window.btoa(city),
            'datadiscover': window.btoa(discover),
        };

        validateAndPushDataLayer(eventData);
    }
}
export default datalayerService;